export const workShiftClockActionEnum = ['clock-in', 'clock-out'] as const
export type WorkShiftClockAction = (typeof workShiftClockActionEnum)[number]
